// Canonical source of truth for Vibio's pricing tiers.
// Light helps creators build; Pro helps them understand, grow, and earn.
// Import these everywhere plan cards/feature lists are rendered so copy never drifts.

export const PLAN_LIGHT = {
    name: 'Light',
    desc: 'All you need to build your Vibio page',
    priceMo: 0,
    priceAnnual: 0,
    cta: 'Get Started',
    features: [
        'Video background',
        'Unlimited links',
        'Unlimited customization',
        'Basic creator insights',
        'Vibio branding',
    ],
}

export const PLAN_PRO = {
    name: 'Pro',
    desc: 'For creators and those looking to grow and monetize',
    priceMo: 8,
    priceAnnual: 80,
    cta: 'Try Free for 14 Days',
    features: [
        // 'Everything in Light',
        'Revenue Links',
        'Link Rankings',
        'Brand Reports',
        'Verified badge',
        'Priority support',
        'No Vibio branding',
    ],
}

export const PLAN_LIST = [PLAN_LIGHT, PLAN_PRO]
